import Modal from "./plugins/modal";

export const modal = new Modal()
